<template><section><!-- ---
title: Vue基础系列之框架选型
date: 2022-11-16
tags: Vue基础系列
set: BaseVue
--- -->
<p>框架选型主要考虑的几个因素包含有：</p>
<ul>
<li><strong>应用</strong>：是否能够满足大部分应用的需求</li>
<li><strong>生态</strong>：框架的生态是否丰富？是否拥有我们所需要的功能组件？技术选型要考虑的一个因素是生态系统，即是否有对应的可选择的组件、库是否足够丰富？</li>
<li><strong>兼容性</strong>：不同框架对于不同浏览器的支持程度如何？由于实现机制的不同，框架会对浏览器有一定的要求。</li>
<li><strong>迁移成本</strong>：是否能以最小的代价迁移现有的应用？当我们选定A框架时，往往后面编写的代码都难以迁移到B框架。比如我们使用React编写的组件，无法直接在Angular或者Vue中使用。尽管随着Web Components技术的发展，跨框架使用变得越来越有希望，但是这也意味着我们需要做大量的适配。</li>
<li><strong>学习成本</strong>：团队成员能否快速掌握该框架？框架拥有自己的设计思想，它可能有更适合的用户群。如Angular其总体的架构思想依赖注入、强类型等，更适合那些有后端经验的开发者。如Vue框架更容易上手，适合初学者进行Web开发。而对于一个没有经验的新手，直接使用Angular框架，则需要较长的学习时间。</li>
</ul>
<h3>一. Vue</h3>
<p>网络选型的主要考虑选Vue的考虑包括：</p>
<ul>
<li>体积小、复杂度低：如果项目主要支持移动端页面，Vue体积较小，网络性能角度相比React更适合移动端，特别是Vue3打包体积更小，性能更优，React相比之下更适合大型相对更复杂的SPA</li>
<li>上手成本、迁移成本低：Vue的学习和上手成本相对更低，框架本身提供了大量丰富的中文文档，这也为Vue的发展和使用带来巨大的优势。</li>
<li>兼容性：Vue2浏览器端不支持IE8及以下版本，移动端支持Android 4.2+，iOS 6+；Vue3浏览器端不支持IE，支持Chrome 49+，移动端安卓6.0+。</li>
<li>生态系统：小程序可以使用mpvue , 公众号H5可以使用vux，app开发可以使用weex，PC端可以用nuxt.js，UI框架可以使用elementUI，以上框架都基于vue开发做到了跨平台，有更好的代码复用性，做到了开发习惯的统一；</li>
</ul>
<h3>二. React</h3>
<p>选React的主要考虑包括：</p>
<ul>
<li>原生应用：React的思想不局限于前端领域，它还有React Native、React VR等，它们可以在不同的平台之上运行类React的View层。使用与React语法类似的React Native，我们可以编写出原生的移动应用。此外，我们还可以在Web应用程序与iOS、Android应用程序之间，共享大部分业务逻辑。</li>
<li>更适用于更大型、复杂的系统开发</li>
</ul>
</section></template>

